<div class="row justify-content-center">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <form [formGroup]="allPortFactorForm" class="form-material" (ngSubmit)="register()">
                    <div class="form-body">
                        <h3 class="card-title">Crear / actualizar factor</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Baja puntuación</label>
                                    <input formControlName="lowDesc" type="text"  class="form-control" placeholder="Baja puntuación">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Puntuación media</label>
                                    <input formControlName="midDesc" type="text"  class="form-control" placeholder="Puntuación media">
                                </div>
                            </div>

                        </div>
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Alta puntuación</label>
                                    <input formControlName="highDesc" type="text"  class="form-control" placeholder="Alta puntuación">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Factor</label>
                                    <select formControlName="name" (ngModelChange)="changeFactor($event)" class="form-control custom-select">
                                        <option value="teorico">Teórico</option>
                                        <option value="economico">Económico</option>
                                        <option value="estetico">Estético</option>
                                        <option value="social">Social</option>
                                        <option value="politico">Político</option>
                                        <option value="religioso">Religioso</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success waves-effect pull-right"> Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="card p-20">
    <div class="row form-material">
        <div class="col-md-6 ">
            <div class="form-group">
                <label class="control-label">Factor</label>
                <select [(ngModel)]="selectedFactor" class="form-control custom-select">
                    <option value="teorico">Teórico</option>
                    <option value="economico">Económico</option>
                    <option value="estetico">Estético</option>
                    <option value="social">Social</option>
                    <option value="politico">Político</option>
                    <option value="religioso">Religioso</option>
                </select>
            </div>
        </div>
        <div class="col-md-6">
            <h4>Puntuación baja</h4>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.lowl" class="form-control" placeholder="Intervalo inferior">
            </div>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.lowh" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
        <div class="col-md-6">
            <h4>Puntuación media</h4>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.midl" class="form-control" placeholder="Intervalo inferior">
            </div>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.midh" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
        <div class="col-md-6">
            <h4>Puntuación alta</h4>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.highl"  class="form-control" placeholder="Intervalo inferior">
            </div>
            <div class="form-group">
                <input type="number" [(ngModel)]="ranks.highh" class="form-control" placeholder="Intervalo superior">
            </div>
        </div>
    </div>
    <div>
        <button type="button" (click)="addRank()" class="btn btn-success waves-effect pull-right">Agregar/Reemplazar</button>
    </div>

</div>

<div class="col-12">
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">Rangos declarados</h4>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Factor</th>
                            <th>Bajo</th>
                            <th>Medio</th>
                            <th>Alto</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of ranksArray">
                            <td>{{r.factor}}</td>
                            <td>{{r.lowl}} - {{r.lowh}}</td>
                            <td>{{r.midl}} - {{r.midh}}</td>
                            <td>{{r.highl}} - {{r.highh}}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>